import type { en } from "./en.ts";

export const fr: typeof en = {
    Navigation: {
        me: {
            label: "Moi",
            description: "Votre profil"
        }
    },
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Aller à",
        openNavigation: "Ouvrir la navigation",
        closeNavigation: "Fermer la navigation",
        primaryNavigation: "Principale",
        openUserMenu: "Ouvrir le menu de l’espace de travail et de l’utilisateur",
        accountSettings: "Paramètres personnels",
        organizationSettings: "Paramètres de l’organisation",
        workspace: "Espace de travail",
        currentWorkspace: "Espace de travail actuel",
        switchWorkspaceError: "Impossible de changer d’espace de travail. Veuillez réessayer.",
        loadingWorkspaces: "Chargement des espaces de travail",
        switchingWorkspace: "Changement d’espace de travail",
        logout: "Se déconnecter",
        helpCenter: "Centre d’aide",
        helpCenterUrl: "https://help.workleap.com/fr/collections/19772749-le-nouveau-workleap",
        opensInNewTab: "s’ouvre dans un nouvel onglet",
        takeTheTour: "Faire la visite guidée",
        resizeAgentPanel: "Redimensionner le panneau de l’agent",
        skipToMainContent: "Passer au contenu principal"
    },
    AssistantTabIndicator: {
        working: "En cours…",
        done: "Terminé",
        error: "Erreur"
    },
    CreateMenu: {
        create: "Créer",
        newSurvey: "Nouveau sondage",
        newReviewCycle: "Nouveau cycle d’évaluation",
        newPlan: "Nouveau plan"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Fermer le menu"
    },
    TabsLayout: {
        tabs: "Onglets"
    },
    SectionMenuTrigger: {
        openMenu: "{{title}}, ouvrir le menu"
    },
    ModuleErrorBoundary: {
        title: "Une erreur est survenue",
        description: "Nous n’avons pas pu charger cette page. Vous pouvez réessayer ou retourner à l’accueil.",
        retry: "Réessayer",
        goHome: "Retour à l’accueil"
    },
    NotFoundPage: {
        title: "Page introuvable",
        code: "404",
        description: "Cette page est introuvable.",
        backHome: "Retour à l’accueil"
    },
    OrganizationAccessPage: {
        title: "Non disponible",
        heading: "Pas encore disponible pour votre organisation",
        body: "Votre organisation n’a pas accès à la nouvelle expérience Workleap. Vous pouvez continuer à utiliser l’expérience Workleap classique.",
        backToWorkleap: "Retour à Workleap"
    },
    RootErrorBoundary: {
        title: "Une erreur est survenue",
        description: "L’application n’a pas pu démarrer. Essayez de rafraîchir la page ou de retourner à l’accueil.",
        goHome: "Retour à l’accueil"
    },
    BootstrappingRoute: {
        loading: "Chargement"
    },
    unmanagedMutationErrors: {
        toastMessage: "Une erreur est survenue. Veuillez réessayer."
    },
    CommandMenu: {
        placeholder: "Aller à",
        noResults: "Aucun résultat ne correspond à votre recherche.",
        searching: "Recherche...",
        dialogLabel: "Palette de commandes",
        searchLabel: "Recherche rapide",
        sections: {
            people: "Personnes",
            teams: "Équipes"
        },
        memberCount_one: "{{count}} membre",
        memberCount_other: "{{count}} membres",
        footer: {
            navigate: "naviguer",
            open: "ouvrir",
            escToClose: "esc pour fermer"
        }
    },
    ProductTour: {
        stepCounter: "{{current}} sur {{total}}",
        skip: "Passer la visite",
        back: "Retour",
        next: "Suivant",
        done: "Terminé",
        stepAnnouncement: "Étape {{current}} sur {{total}} : {{title}}"
    },
    OnboardingProductTour: {
        agent: {
            title: "Ne partez plus jamais de zéro",
            body: "Posez n’importe quelle question, depuis n’importe quelle page. Votre agent rédige les ordres du jour de vos 1:1, vos réponses et vos évaluations à partir des données de votre équipe, prêts à être modifiés."
        },
        navigation: {
            title: "Sachez toujours où regarder",
            bodyIndividual: "Consultez votre propre travail et celui de toute l’organisation sans changer d’outil. Les objectifs et les Bonnes Vibes sont présents aux deux niveaux.",
            bodyTeam: "Consultez votre propre travail, celui de votre équipe et celui de toute l’organisation sans changer d’outil. Les objectifs et les Bonnes Vibes sont présents à tous les niveaux."
        },
        shortcuts: {
            title: "Allez droit au but",
            body: "Appuyez sur {{shortcut}} et tapez un nom ou une page au lieu de fouiller dans les menus. Utilisez + pour envoyer des Bonnes Vibes ou créer un objectif depuis n’importe quelle page."
        },
        analytics: {
            title: "Aidez chaque équipe à s’épanouir",
            body: "Comparez la situation des équipes pour voir où votre soutien fera la plus grande différence."
        },
        restart: {
            title: "Revenez quand vous voulez",
            body: "Choisissez « Faire la visite guidée » dans le menu de votre profil quand vous voulez un rappel."
        }
    }
};
